<template>
    <div id="usereditdpa">
        <div class="index_left">
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox" style="height: 81.5vh;">
                    <div class="usereditdpa gov_usereditdpa">
                        <div class="inputbox">
                            <label>原始密码</label><input type="password" placeholder="原始密码" @change="editbtn = true"
                                v-model="oldpassw">
                        </div>
                        <div class="inputbox">
                            <label>新密码</label><input type="password" placeholder="新密码" @change="editbtn = true"
                                v-model="newpassw">
                        </div>
                        <div class="inputbox">
                            <label>确认新密码</label><input type="password" placeholder="确认新密码" @change="editbtn = true"
                                v-model="newpassw1">
                        </div>
                        <div class="inputbox1">
                            <div :class="{ 'submitbtn': true, 'editsave': editbtn && !loading }" @click="saveeditFun()"
                                style="margin-top:0;">确认修改</div>
                        </div>
                        <!-- <p class="errortext inputbox1">{{ errortext }}</p> -->
                    </div>


                </div>
            </div>
        </div>

    </div>
</template>
<script>

export default {
    name: 'editPassword',
    data() {
        return {
            userdata: {},
            title: '用户中心-修改密码',
            editbtn: false,
            oldpassw: "", newpassw: '', newpassw1: '', errortext: '',
            loading: false,
        }
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    methods: {
        saveeditFun() {
            if (!this.loading) {
                if (this.editbtn) {
                    if (this.newpassw.length == 0 || this.oldpassw.length == 0 || this.newpassw1.length == 0) {
                        this.errortext = '密码不能为空';
                        this.$message.error(this.errortext);
                        return;
                    }
                    if (this.newpassw1 != this.newpassw) {
                        this.errortext = '两次新密码不一致';
                        this.$message.error(this.errortext);
                        return;
                    }
                    var _this = this;
                    this.loading = true;
                    var ajaxurl = this.$api.cyl.usercenter.updatepassword();
                    $.ajax({
                        type: "POST",
                        url: ajaxurl,
                        data: { oldpw: this.oldpassw, newpw: this.newpassw1, },
                        headers: { AuthToken: this.userdata.token },
                        success: function (res) {
                            console.log(res);
                            if (res.success) {
                                this.loading = false;
                                _this.$message.success('修改成功，请重新登录');
                                _this.loginOut();
                            } else {
                                _this.loading = false;
                                _this.errortext = res.msg;
                                _this.$message.error(_this.errortext);
                            }
                        }
                    });
                    console.log(this.oldpassw, this.newpassw1);
                }

            }
        }


    }
}  
</script>

<style lang="less" scoped>
//修改密码 
.usereditdpa {
    padding-top: 100px;
    // padding-bottom: 320px;

    label {
        width: 108px;
        letter-spacing: 2px;
        float: left;
        line-height: 44px;
        margin-right: 30px;
        text-align: right;
    }

    .inputbox {
        height: 44px;
        overflow: hidden;
        margin: 0 auto 32px;
    }

    .inputbox1 {
        height: 44px;
        overflow: hidden;
        margin: 0 auto;
    }

    .errortext {
        width: 200px;
        margin: 0 auto;
        text-align: right;
        color: #ff0000;
    }

    input,
    select {
        border: 1px solid #ccc;
        height: 42px;
        line-height: 42px;
        font-size: 16px;
        float: left;
        padding: 0 15px;
        border-radius: 5px;
        width: 320px;
    }

    .submitbtn {
        margin-left: 156px;
        width: 320px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        border-radius: 4px;
        cursor: pointer;
        background: #eee;
        color: #999;

        &.editsave {
            background: #2c5282;
            color: #fff;
        }
    }
}
</style>
